// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3sHnH","item-logo":"styles_item-logo__Njisq","logo":"styles_logo__1K_4h","grid":"styles_grid__3LHdi","button":"styles_button__2Bzgq"};